import React, { useEffect, useState, useRef, useMemo } from 'react';
import CountUp from "react-countup";
import { ReactComponent as Icon1 } from '@/assets/background/svg/group1_1.svg';
import { ReactComponent as Icon2 } from '@/assets/background/svg/group1_2.svg';
import { ReactComponent as Icon3 } from '@/assets/background/svg/group1_3.svg';
import { ReactComponent as Icon4 } from '@/assets/background/svg/group1_4.svg';
import { ReactComponent as Icon5 } from '@/assets/background/svg/group1_5.svg';
import styles from './index.less';

/** 统计看板 */
export default ({ callback =()=> {}, install }) => {
  const [swiper, setSwiper] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const tabSwiperRef = useRef(null);

  const speed = '1'
  const dataSet = useMemo(()=>[
    {
      icon: <Icon1 />,
      count: install ? <CountUp start={0} end={9} duration={speed} />: 0, 
      unit: '大服务',
    },
    {
      icon: <Icon2 />,
      count: install ? <><CountUp start={0} end={9000} duration={speed} />+</>: 0,
      unit: '开发者',
    },
    {
      icon: <Icon3 />,
      count: install ? <><CountUp start={0} end={83} duration={speed} />.4k</>: 0,
      unit: '次日均服务',
    },
    {
      icon: <Icon4 />,
      count: install ? <><CountUp start={0} end={500} duration={speed} /></>: 0, 
      unit: '台免费机器',
    },
    {
      icon: <Icon5 />,
      count: install ? <><CountUp start={0} end={21} duration={speed} /></>: 0, 
      unit: '所合作高校实验课程支撑',
    }
  ], [install])


  const RowItem = ({ param, index: id })=> (
    <div key={id} className={styles.row_item} style={{ 
      marginRight: (dataSet.length == id + 1) ? 0 : '20px', 
      backdropFilter: 'blur(5px)',  // 做模糊背景
    }}>
       <div className={styles.logo}>{param.icon}</div>
       <div style={id === 0 ? { marginTop: '-30px'}: {}}>
        {id === 1 ?
          <>
            <span>{param.count}</span>
            <div>{param.unit}</div>
          </>
          :
          <>
            <span>{param.count}</span>
            <span>{param?.unit?.slice(0, 1)}</span>
            <div>{param?.unit?.slice(1, 30)}</div>
          </>
        }
       </div>
    </div>
  )


  return (
    <div style={{ position: 'relative' }}>
      {/* 展示数据 */}
      <div className={styles.statistic_container} style={{ position: 'absolute',top:0, width: '1190px' }}>
          {dataSet.map((item, i)=>
            <RowItem param={item} key={i} index={i}/>
          )}
      </div>
    </div>
  );
};
